/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum LoadingCondition {
  BALLASTED = 'BALLASTED',
  LOADED = 'LOADED',
  HALF_LADEN = 'HALF_LADEN',
}
